import { Api as Customer } from './customer';
import { Api as Goods } from './goods';
import { Api as Order } from './order';
import { Api as Settlement } from './settlement';
import { Api as Smc } from './smc';

import { serviceConfig } from '@/config/request/swaggerServiceConfig';

export const Api = { Customer, Goods, Order, Settlement, Smc };

const warpperServiceConfig = (serviceConfig: any, ctx: { name: string; basePath: string; }) => {
        const newConfig = { ...serviceConfig };
        if (newConfig.baseURL) {
            newConfig.baseURL = newConfig.baseURL + ctx.basePath;
        }
        return newConfig;
    };

const customer = new Customer(warpperServiceConfig(serviceConfig, { name: 'customer', basePath: '/customer' }));
const goods = new Goods(warpperServiceConfig(serviceConfig, { name: 'goods', basePath: '/goods' }));
const order = new Order(warpperServiceConfig(serviceConfig, { name: 'order', basePath: '/order' }));
const settlement = new Settlement(warpperServiceConfig(serviceConfig, { name: 'settlement', basePath: '/settlement' }));
const smc = new Smc(warpperServiceConfig(serviceConfig, { name: 'smc', basePath: '/smc' }));

export const apiInstanceList = [{ key: 'customer', instance: customer }, { key: 'goods', instance: goods }, { key: 'order', instance: order }, { key: 'settlement', instance: settlement }, { key: 'smc', instance: smc }];

export const api = { customer, goods, order, settlement, smc };